<template>
  <b-row
    id="mobile-header"
    no-gutters
  >
    <b-col
      v-if="!disableMobileHamburger"
      cols="auto"
      class="mr-auto"
    >
      <HamburgerMenu />
    </b-col>

    <b-col cols="auto">
      <b-img
        :src="logoImg"
        :state="Boolean(logoImg)"
        :style="{'max-height': '3rem', 'object-fit': 'contain'}"
      />
    </b-col>

    <b-col
      cols="12"
      class="mt-2 mb-0"
    >
      <ClickableBreadcrumbs v-if="!disableMobileBreadcrumb" />
    </b-col>
  </b-row>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import HamburgerMenu from '@/components/public/mobile/HamburgerMenu.vue'
import ClickableBreadcrumbs from '@/components/public/ClickableBreadcrumbs.vue'

const components = {
  HamburgerMenu,
  ClickableBreadcrumbs,
}

@Component({ components })
export default class MobileHeader extends Vue {
  get logoImg () {
    const logo = this.$typedStore.primary.app.config.appConfig.logo
    return logo ? logo.img ? this.$typedStore.primary.entities.images.image(logo.img) : logo : null
  }

  get disableMobileHamburger () {
    return this.$typedStore.primary.app.config.appConfig.disableMobileHamburger
  }

  get disableMobileBreadcrumb () {
    return this.$typedStore.primary.app.config.appConfig.disableMobileBreadcrumb
  }
}

</script>

<style scoped>
#mobile-header {
  width: 100%;
}
</style>
